module.exports = __webpack_public_path__ + "static/media/arrow_left.4a3c258d.svg";